import { createRouter, createWebHistory } from "vue-router";
import portalTop from "./src/components/portalTop.vue";
import portalDashboard from "./src/components/portalDashboard.vue";
import dashboardTop from "./src/components/dashboard/dashboardTop.vue";
import dashboardIndividual from "./src/components/dashboard/dashboardIndividual.vue";
import developmentPortal from "./src/components/developmentPortal.vue";
import developmentTop from "./src/components/developmentPortal/developmentTop.vue";
import developmentContentRelease from "./src/components/developmentPortal/contents/developmentRelease.vue";
import developmentContentAboutApi from "./src/components/developmentPortal/contents/developmentAboutApi.vue";
import developmentContentHowToUse from "./src/components/developmentPortal/contents/developmentHowToUse.vue";
import developmentContentRefarense from "./src/components/developmentPortal/contents/developmentRefarense.vue";
import developmentContentData from "./src/components/developmentPortal/contents/developmentData.vue";
import developmentContentSampleCode from "./src/components/developmentPortal/contents/developmentSampleCode.vue";
import developmentContentCredit from "./src/components/developmentPortal/contents/developmentCredit.vue";
import developmentContentApiTerms from "./src/components/developmentPortal/contents/developmentApiTerms.vue";
import NotFound from "./src/components/NotFound.vue";

const routes = [
  {
    path: "/",
    name: "portalTop",
    component: portalTop,
    meta: { title: "やまなしデータプラットフォーム | 山梨県のオープンデータ利活用" },
  },
  {
    path: "/dashboard",
    component: portalDashboard,
    meta: { title: "ダッシュボード一覧 | やまなしデータプラットフォーム" },
    children: [
      { path: "", name: "dashboardTop", component: dashboardTop },
      {
        path: ":categoryEn",
        name: "dashboardIndividual",
        meta: { title: "個別ダッシュボード | やまなしデータプラットフォーム" },
        component: dashboardIndividual,
        props: true,
      },
    ],
  },
  {
    path: "/developer-portal",
    component: developmentPortal,
    meta: { title: "開発者ページ | やまなしデータプラットフォーム" },
    children: [
      {
        path: "",
        name: "developmentTop",
        component: developmentTop,
        meta: { title: "開発者ページ | やまなしデータプラットフォーム" },
        children: [
          {
            path: "release",
            name: "developmentContentRelease",
            component: developmentContentRelease,
            meta: { title: "リリース | 開発者ページ | やまなしデータプラットフォーム" },
          },
          {
            path: "about-api",
            name: "developmentContentAboutApi",
            component: developmentContentAboutApi,
            meta: { title: "API概要 | 開発者ページ | やまなしデータプラットフォーム" },
          },
          {
            path: "howtouse",
            name: "developmentContentHowToUse",
            component: developmentContentHowToUse,
            meta: { title: "利用手順 | 開発者ページ | やまなしデータプラットフォーム" },
          },
          {
            path: "refarense",
            name: "developmentContentRefarense",
            component: developmentContentRefarense,
            meta: { title: "仕様 | 開発者ページ | やまなしデータプラットフォーム" },
          },
          {
            path: "data",
            name: "developmentContentData",
            component: developmentContentData,
            meta: { title: "提供データ | 開発者ページ | やまなしデータプラットフォーム" },
          },
          {
            path: "sample-code",
            name: "developmentContentSampleCode",
            component: developmentContentSampleCode,
            meta: { title: "サンプルコード | 開発者ページ | やまなしデータプラットフォーム" },
          },
          {
            path: "credit",
            name: "developmentContentCredit",
            component: developmentContentCredit,
            meta: { title: "クレジット表示 | 開発者ページ | やまなしデータプラットフォーム" },
          },
          {
            path: "api-terms",
            name: "developmentApiTerms",
            component: developmentContentApiTerms,
            meta: { title: "API利用規約 | 開発者ページ | やまなしデータプラットフォーム" },
          },
        ],
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
    meta: { title: 'ページが見つかりません' }
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const DEFAULT_TITLE = "やまなしデータプラットフォーム";

router.afterEach((to) => {
  let title = to.meta.title;
  if (title === undefined) {
    document.title = DEFAULT_TITLE;
  } else {
    document.title = title;
  }
});

export default router;
